import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AvailabilityListsComponent } from './availability-lists.component';
import { AngularMaterialModule } from '../../angular-material/angular-material.module';
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { InlineSVGModule } from "ng-inline-svg";
import { PipesModule } from "../../pipes/index";



@NgModule({
  declarations: [AvailabilityListsComponent],
  imports: [
    CommonModule,
    AngularMaterialModule,
    FormsModule, ReactiveFormsModule,
    InlineSVGModule, PipesModule
  ],
  exports:[ AvailabilityListsComponent ]
})
export class AvailabilityListsModule { }
